import { GetExcelRequest, GetRequest, PostRequest, PutRequest } from "../../service"

const ControllerName = "BrokerPatient"

export const GetBrokerPatientsListGroups = (searchUrl,isSubmitted=false) =>
    GetRequest(`${ControllerName}${searchUrl}&isSubmited=${isSubmitted}`)

export const GetBrokerPatientsTemplate = () =>
    GetExcelRequest(`${ControllerName}/excel/broker-patients-template`)


export const GetBrokerStats = () =>
    GetRequest(`${ControllerName}/stats`)

export const ImportBrokerPatients = (formData) =>
    PutRequest(`${ControllerName}/excel/import-patients`, formData)


export const SubmitBrokerPatientsRequests = (body) =>
    PostRequest(`${ControllerName}/submit-requests`, body)